import {
  GET_LIST_NOTICE_FROM_TCT,
  GET_LIST_NOTICE_FROM_TCT_FAIL,
  GET_LIST_NOTICE_FROM_TCT_SUCCESS,
  RESET_LIST_NOTICE_FROM_TCT,
  SET_COLUMN_VISIBLE_NOTICE_FROM_TCT,
} from "./actionTypes";

const INIT_STATE = {
  type: null,
  // Đăng ký sử dụng
  noticeFromTCT: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  // Detail modal
  detail: {
    loading: false,
    data: null,
  },
  error: null,
};

const noticeTCT = (state = INIT_STATE, action) => {
  const curNoticeFromTCT = state.noticeFromTCT;
  switch (action.type) {
    // Đăng ký sử dụng
    case GET_LIST_NOTICE_FROM_TCT:
      return {
        ...state,
        noticeFromTCT: {
          ...curNoticeFromTCT,
          loading: true,
          //   params: action.params,
        },
      };
    case GET_LIST_NOTICE_FROM_TCT_SUCCESS:
      return {
        ...state,
        noticeFromTCT: {
          ...curNoticeFromTCT,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case GET_LIST_NOTICE_FROM_TCT_FAIL:
      return {
        ...state,
        noticeFromTCT: {
          ...curNoticeFromTCT,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case RESET_LIST_NOTICE_FROM_TCT:
      return {
        ...state,
        noticeFromTCT: {
          ...curNoticeFromTCT,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    // Set column
    case SET_COLUMN_VISIBLE_NOTICE_FROM_TCT:
      curNoticeFromTCT.columnsVisible[action.field] = action.value;
      return {
        ...state,
        noticeFromTCT: {
          ...curNoticeFromTCT,
        },
      };
    default:
      return state;
  }
};

export default noticeTCT;
